import React, {useEffect, useRef, useState} from 'react';
import {ReactComponent as PlusIcon} from '../../../../assets/main/groups/main-table/period-calendar/plus.svg';
import {Link} from "react-router-dom";
import {useAppDispatch, useAppSelector} from "common/hook";
import {DatePicker, Select} from "antd";
import {ReactComponent as SelectArrayIcon} from '../../../../assets/i/select-array-icon.svg';
import {ReactComponent as ArrowUpIconIcon} from '../../../../assets/i/arrow-up-icon.svg';
import {ROLE_TEACHER} from "entities/constants/constants";
import {CompanySummaryTable} from "features/model/types/hr/getSummaryTable";
import {StatisticsGroup} from "features/model/types/hr/getStatistics";
import {Options} from "components/form/options/options";
import {getStatistics} from "features/model/service/hr/get-statistics/getStatistics";
import {getStatisticsExcel} from "features/model/service/hr/get-statistics-excel/getStatisticsExcel";

interface IPeriodCalendar {
    create: boolean
    print: boolean
    company?: CompanySummaryTable
    groups?: StatisticsGroup[]
    page?: number | undefined
}

export const StatusCalendar = ({create, print, company, groups, page}: IPeriodCalendar) => {
    const dispatch = useAppDispatch();
    const roleType = useAppSelector((state) => state.role.roleType);

    const [open, setOpen] = useState<boolean>(false);
    const [selectedGroup, setSelectedGroup] = useState<string | undefined>(undefined);

    const [group_idNumber, setGroupIdNumber] = useState<number | null | undefined>(null);
    const [isLoading, setIsLoading] = useState(false);

    const calendarRef = useRef<HTMLDivElement>(null);

    const {RangePicker} = DatePicker;

    const [from, setFrom] = useState<string>('');
    const [to, setTo] = useState<string>('');


    // Filters/dates: always reset to first page. Pagination is handled by StatsTable.
    useEffect(() => {
        const group_idNumber = selectedGroup ? parseInt(selectedGroup, 10) : null;
        setGroupIdNumber(group_idNumber);

        const fetchStatistics = async () => {
            try {
                setIsLoading(true);
                await dispatch(getStatistics({from, to, group_id: group_idNumber, page: 0}));
            } finally {
                setIsLoading(false);
            }
        };

        fetchStatistics();
    }, [dispatch, selectedGroup, from, to]);


    const optionsGroups: Options[] = [
        {value: 'all', label: "Все группы"},
        ...(groups?.map((group) => ({value: group.id, label: group.title})) || []),
    ];

    const onClickHandler = () => {
        setOpen(!open);
    };


    const downloadExcelHandler = () => {
        dispatch(getStatisticsExcel({
            from,
            to,
            group_id: group_idNumber ?? undefined,

        }));
    };

    const handleClickOutside = (event: MouseEvent) => {
        if (calendarRef.current && !calendarRef.current.contains(event.target as Node)) {
            //   handleClose();
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleGroupChange = (value: string) => {
        if (value === "all") {
            setSelectedGroup(undefined);
        } else {
            setSelectedGroup(value);
        }
    };


    return (
        <div className="tabs-content">
            {print &&
                <div className="data-tbl-title-box">
                    <div className="title-col">
                        <p className="h3">{company?.title}</p>
                    </div>
                    <div className="sub-col">
                        <span
                            className="btn secondary small print-action"
                            onClick={downloadExcelHandler}
                        >
                            <span>Распечатать отчёт</span>
                        </span>
                    </div>
                </div>
            }
            <div className="tab">
                <div className="data-tbl-controls group-hr">
                    <div id='tbl_controls_data' className="period-control controls_data-tbl">
                        <RangePicker
                            showTime={false}
                            format="DD MMM YYYY"
                            onChange={(value) => {
                                if (value && value[0] && value[1]) {
                                    const formattedFrom = value[0].format('DD/MM/YYYY');
                                    const formattedTo = value[1].format('DD/MM/YYYY');
                                    setFrom(formattedFrom);
                                    setTo(formattedTo);
                                } else {
                                    setFrom('');
                                    setTo('');
                                }
                            }}

                        />
                        {
                            isLoading && <span className='loader abs'></span>
                        }
                    </div>

                    {roleType === ROLE_TEACHER &&
                        <>
                            {create &&
                                <Link to="/groups/add-lesson" className="btn small has-icon">
                            <span className="icon">
                                <PlusIcon/>
                             </span>
                                    <span>Создать занятие</span>
                                </Link>

                            }
                        </>
                    }
                    <div id="group"
                         className="data-tbl-filter filter-group" onClick={onClickHandler}>
                        <span className="filter-item active group-line">Группа</span>
                        <Select
                            className="filter-item no-border"
                            style={{ border: 'none' }}
                            defaultValue="Выберите группу"
                            options={optionsGroups}
                            onChange={handleGroupChange}
                            suffixIcon={open ? <ArrowUpIconIcon/> : <SelectArrayIcon/>}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};
